import { BaseEdge, getSmoothStepPath } from "reactflow";

export default function LabelEdge({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd
}) {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    centerY: sourceY + 50,
    centerX: sourceX + 50
  });
  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} type="smoothstep" style={style} />
    </>
  );
}
